import { logAdsVerbose } from '../config/ads';
import { http, getApiCountryCode } from './http';

export const getAdPlacements = async (params = {}) => {
  const cc = getApiCountryCode();
  const merged = cc && !params.country ? { ...params, country: cc } : params;
  if (logAdsVerbose) {
    console.log('[simimovies/ads] HTTP GET /api/v1/ads/placements', merged);
  }
  const res = await http.get('/api/v1/ads/placements', { params: merged });
  const data = res.data?.data ?? res.data ?? [];
  const list = Array.isArray(data) ? data : [];
  if (logAdsVerbose) {
    const first = list[0];
    console.log('[simimovies/ads] placements HTTP response', {
      status: res.status,
      count: list.length,
      firstCampaignId: first?._id != null ? String(first._id) : null,
      firstCreativeImage: first?.creative?.imageUrl ? 'yes' : 'no',
    });
  }
  return list;
};

export const trackAdImpression = async (payload) => {
  const cc = getApiCountryCode();
  await http.post('/api/v1/ads/events/impression', { ...payload, ...(cc && !payload.country ? { country: cc } : {}) });
};

export const trackAdClick = async (payload) => {
  const cc = getApiCountryCode();
  await http.post('/api/v1/ads/events/click', { ...payload, ...(cc && !payload.country ? { country: cc } : {}) });
};
